import { isEncryptionEnabled } from '~libs/encryptionSettings';

import { SearchProps } from '~components/form-fields/search';

import { selectLookupClients } from '~main/selectors/clients/clients';

// Search for the Print to Sign viewer (TAV-3313). Client name text search is hidden when encryption is
// on, the same as on the Budgets list; the Client lookup still works then.
const printToSignRecordsSearchFields: SearchProps = {
  client_name: {
    defaultShow: true,
    type: 'text-like',
    field: 'client.full_name',
    placeholder: 'Client Name',
    caption: 'Client Name',
    hidden: isEncryptionEnabled,
  },
  client: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'client_id',
    caption: 'Client',
    selectorOptions: selectLookupClients,
  },
  budget: {
    defaultShow: true,
    type: 'text-like',
    field: 'budget.reference',
    placeholder: 'Budget Reference',
    caption: 'Budget',
  },
};

export default printToSignRecordsSearchFields;
